import {Component, EventEmitter, Input, Output} from '@angular/core';
import {StateService} from "../../../service/state";
import {ApiService} from "../../../service/api";
import {CheckoutComponent} from "../../../pages/checkout/checkout.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CartService} from "../../../service/cart";
import {PhonevalidatorDirective} from "../../../directives/phonevalidator.directive";

@Component({
    selector: 'checkout-address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss']
})
export class AddressComponent {

    @Input('checkout')
    public checkout: CheckoutComponent;

    @Output('address')
    public address = new EventEmitter();

    public addressForm: FormGroup;
    public pickupForm: FormGroup;
    public loggedIn: boolean = false;

    public firstname: string;
    public surname: string;

    public addresses: any[] = [];
    private _selected_address: any = -1;
    get selected_address(): any {
        return this._selected_address;
    }

    set selected_address(value: any) {
        if (!value.firstname) {
            value.firstname = this.firstname;
        }

        if (!value.surname) {
            value.surname = this.surname;
        }

        if (value.pickup) {
            this.cart.shipment = false;
        } else {
            this.cart.shipment = value.country;
        }

        this.address.next(value);
        this._selected_address = value;
    }

    constructor(public state: StateService, public api: ApiService, public fb: FormBuilder, public cart: CartService) {
        this.addressForm = fb.group({
            firstname: [this.firstname],
            surname: [this.surname],
            street: ['', Validators.required],
            streetnumber: ['', Validators.required],
            city: ['', Validators.required],
            country: ['AT'],
            zip: ['', Validators.required],
            telephone: ['', PhonevalidatorDirective()],
            email: ['', Validators.email]
        });

        this.pickupForm = fb.group({
            firstname: [this.firstname],
            surname: [this.surname],
            pickup: ['seiersberg'],
            telephone: ['', PhonevalidatorDirective()],
            email: ['', Validators.email]
        });

        let onLoginChange = (user) => {
            this.loggedIn = !!user;

            if (user) {
                this.firstname = user.firstname;
                this.surname = user.surname;

                this.addressForm.patchValue({
                    firstname: user.firstname,
                    surname: user.surname,
                    email: user.email,
                    telephone: user.telephone
                });

                this.pickupForm.patchValue({
                    firstname: user.firstname,
                    surname: user.surname,
                    email: user.email,
                    telephone: user.telephone
                });
            }

            if (this.loggedIn) {
                this.api.call('/checkout/index/addresses').then((result) => {
                    this.addresses = result;

                    this.addresses.forEach((adr) => {
                        if (adr.defaultaddress == "1") {
                            this.selected_address = adr;
                            return false;
                        }
                    })
                })
            } else {
                this.selected_address = this.addressForm.getRawValue();
                this.addresses = [];
            }
        }

        state.getState('user').then(onLoginChange);
        state.watchState('user').subscribe(onLoginChange);
    }

    public create(): void {
        if (this.addressForm.valid && this.loggedIn) {
            this.api.call('/checkout/index/createaddress', {
                address: this.addressForm.getRawValue()
            }).then((address) => {
                this.api.call('/checkout/index/addresses').then((result) => {
                    this.addresses = result;
                    this.addresses.forEach((adr) => {
                        if (adr.address_id == address.json().address_id) {
                            this.selected_address = adr;
                            return false;
                        }
                    })
                })
            })
        } else if (this.addressForm.valid) {
            this.address.next(this.addressForm.getRawValue());
        }

        this.checkout.next();
    }

    public pickup(): void {
        if (this.pickupForm.valid) {
            var data = this.pickupForm.getRawValue();
            this.address.next(data);
        }

        this.checkout.next();
    }

    public favorite(address): void {
        this.addresses.forEach(adr => adr.defaultaddress = undefined);
        address.defaultaddress = "1";
        this.api.call('/checkout/index/favoriteaddress', {'address_id': address.address_id});
    }

    public deleteAddr(address): void {
        if (this.selected_address == address) {
            this.selected_address = this.addressForm.getRawValue();
        }

        this.addresses.splice(this.addresses.indexOf(address), 1);
        this.api.call('/checkout/index/deleteaddress', {'address_id': address.address_id});
    }

}



// WEBPACK FOOTER //
// ./src/app/components/checkout/address/address.component.ts